export default __webpack_public_path__ + "static/media/papertube_controller_171117.65d3d152.nproj";